import '../../monitoring/charts/chart_view.js.coffee'

Namespace 'CustomerVisualMode.Charts'

class CustomerVisualMode.Charts.BarGraphChartView extends Monitoring.Views.Charts.ChartView
  initialize: (
    {
      @data,
      @maxHeight = 450,
      @minHeight = 250,
      @dataLabelFormatter = @_formatDataLabel
      @tooltipFormatter = @_formatTooltip
    }
  ) ->

  renderChart: ->
    @chart = new Highcharts.Chart(@_highchartsOptions())

  setChartWidth: (singleDimensionView) ->
    el = singleDimensionView.$el
    isMaximized = singleDimensionView.widget.get('is_maximized')
    el.find('.highcharts-container, .processing').css('height', if isMaximized then @maxHeight else @minHeight)

  _highchartsOptions: ->
    dataLabelFormatter = @dataLabelFormatter
    tooltipFormatter = @tooltipFormatter
    {
      chart: {
        type: 'bar',
        renderTo: @$el[0]
      },
      legend: {
        align: 'right',
        verticalAlign: 'top',
        layout: 'vertical',
        itemMarginTop: 1
      },
      title: {
        text: null
      },
      exporting: {
        enabled: false
      },
      xAxis: {
        type: 'category',
        labels: {
          enabled: false
        }
      },
      yAxis: {
        min: 0,
        title: {
          text: null
        }
      },
      tooltip: {
        headerFormat: null,
        formatter: -> tooltipFormatter(this.key, this.y)
      }
      plotOptions: {
        bar: {
          dataLabels: {
            enabled: true,
            color: '#000000',
            formatter: -> dataLabelFormatter(this.y)
          },
          minPointLength: 3,
          grouping: false,
          cursor: 'pointer',
          events: {
            click: (event) => @trigger('singledimension:click', event.point.id)
          }
        }
      }
      series: @_createSeries()
      isHierarchical: true
      isBarHierarchyNavigation: true
    }

  updateData: (data) ->
    @data = data
    @chart.xAxis[0].setCategories(@_createCategories(), false)
    @chart.update({series: @_createSeries()}, true, true)

  _createSeries: ->
    cc = @customColors()
    @data.map((serie) ->
      {
        name: serie.x,
        color: cc[Object.keys(cc).find((a) => serie.id.toString().toLowerCase().match(a))],
        data: [{
          id: serie.id,
          name: serie.x,
          y: serie.y
        }]
      }
    )

  _createCategories: ->
    @data.map((serie) -> serie.x)

  _formatDataLabel: (value) ->
    value

  _formatTooltip: (key, value) ->
    "<b>#{key}</b>: #{value}"
